import Lottie from 'react-lottie';

import classNames from './style.module.scss';
import { concatClassNames } from '../../../utils/utilities';

interface InstructionBoxProps {
	title: string;
	subtitle: string;
	animation: object;
	isActive: boolean;
}

const InstructionBox = (props: InstructionBoxProps) => {
	return (
		<div
			className={concatClassNames([
				classNames.instructionBox,
				props.isActive ? classNames.instructionBoxActive : '',
			])}
		>
			<Lottie
				height={100}
				width={100}
				options={{
					loop: true,
					autoplay: props.isActive,
					animationData: props.animation,
					rendererSettings: { preserveAspectRatio: 'xMidYMid slice' },
				}}
			/>

			<div className={classNames.instructionBoxDetails}>
				<div className={classNames.instructionBoxDetailsTitle}>
					{props.title}
				</div>
				<div className={classNames.instructionBoxDetailsBody}>
					{props.subtitle}
				</div>
			</div>
		</div>
	);
};

export default InstructionBox;
